import { useState } from "react";
import { toast } from "sonner";
import { Share2, Download, MessageCircle, Instagram, Loader2, Smartphone, Square } from "lucide-react";
import { freshFindShareUrl } from "@/lib/afmApi";

const pageUrl = () => `${window.location.origin}/fresh-finds`;
const slug = (s) => s.replace(/[^a-z0-9]+/gi, "-").toLowerCase();

export function ShareMenu({ it }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [fmt, setFmt] = useState("square");
  const artists = (it.artists || []).map((a) => a.name).join(", ") || it.main_artist;
  const caption = `🔥 Nuevo estreno: "${it.title}" de ${artists} ya disponible.\nEscúchalo en Always Fresh Finds → ${pageUrl()}${it.spotify_url ? `\n${it.spotify_url}` : ""}`;
  const imgUrl = freshFindShareUrl(it.id, fmt);

  const fetchFile = async () => {
    const b = await (await fetch(imgUrl)).blob();
    return new File([b], `afm-${slug(it.title)}-${fmt === "story" ? "historia" : "post"}.png`, { type: "image/png" });
  };
  const saveFile = (file) => { const a = document.createElement("a"); a.href = URL.createObjectURL(file); a.download = file.name; a.click(); URL.revokeObjectURL(a.href); };
  const download = async () => {
    setBusy(true);
    try { saveFile(await fetchFile()); toast.success("Imagen descargada"); } catch { toast.error("No se pudo generar la imagen"); }
    setBusy(false);
  };
  const whatsapp = () => window.open(`https://wa.me/?text=${encodeURIComponent(caption)}`, "_blank", "noopener");
  const social = async () => {
    setBusy(true);
    try {
      const file = await fetchFile();
      if (navigator.canShare?.({ files: [file] })) {
        await navigator.share({ files: [file], text: caption });
      } else {
        await navigator.clipboard?.writeText(caption).catch(() => {});
        saveFile(file);
        toast.success(fmt === "story" ? "Historia descargada y texto copiado. Súbela a Instagram Stories o TikTok." : "Imagen descargada y texto copiado. Súbela a tu feed de Instagram.");
      }
    } catch (e) { if (e?.name !== "AbortError") toast.error("No se pudo compartir"); }
    setBusy(false);
  };

  const Tab = ({ v, icon: Icon, label }) => (
    <button type="button" data-testid={`share-fmt-${v}-${it.id}`} onClick={() => setFmt(v)} className={`flex flex-1 items-center justify-center gap-1 py-1.5 text-[10px] font-semibold uppercase tracking-wider ${fmt === v ? "bg-[#CA0808] text-white" : "text-white/60 hover:text-white"}`}><Icon className="h-3 w-3" /> {label}</button>
  );

  return (
    <div className="relative">
      <button type="button" data-testid={`share-btn-${it.id}`} onClick={() => setOpen((o) => !o)} className="inline-flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1.5 text-[11px] font-semibold text-white transition-colors hover:bg-[#CA0808]">
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Share2 className="h-3.5 w-3.5" />} Compartir
      </button>
      {open && (
        <div data-testid={`share-menu-${it.id}`} className="absolute bottom-full right-0 z-20 mb-2 w-60 overflow-hidden rounded-xl border border-white/10 bg-[#120404] shadow-2xl">
          <div className="flex border-b border-white/10"><Tab v="square" icon={Square} label="Post 1:1" /><Tab v="story" icon={Smartphone} label="Historia 9:16" /></div>
          <div className="flex h-56 items-center justify-center bg-black/40 p-2">
            <img key={imgUrl} src={imgUrl} alt="" className="max-h-full max-w-full rounded-md object-contain" loading="lazy" />
          </div>
          <button type="button" data-testid={`share-whatsapp-${it.id}`} onClick={whatsapp} className="flex w-full items-center gap-2 px-3 py-2.5 text-left text-xs font-semibold text-white hover:bg-white/10"><MessageCircle className="h-4 w-4 text-[#25D366]" /> WhatsApp</button>
          <button type="button" data-testid={`share-instagram-${it.id}`} onClick={social} className="flex w-full items-center gap-2 px-3 py-2.5 text-left text-xs font-semibold text-white hover:bg-white/10"><Instagram className="h-4 w-4 text-[#E1306C]" /> {fmt === "story" ? "Instagram Stories / TikTok" : "Instagram"}</button>
          <button type="button" data-testid={`share-download-${it.id}`} onClick={download} className="flex w-full items-center gap-2 px-3 py-2.5 text-left text-xs font-semibold text-white hover:bg-white/10"><Download className="h-4 w-4" /> Descargar {fmt === "story" ? "historia" : "imagen"}</button>
        </div>
      )}
    </div>
  );
}
